import script from "./ProfitLoss.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfitLoss.vue?vue&type=script&setup=true&lang=ts"

import "./ProfitLoss.vue?vue&type=style&index=0&id=5a6d0597&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6d0597"]])

export default __exports__